import React, { useContext } from 'react'
import { ContentBoxedDisplayContext } from './ContentBoxedDisplay'
import Skeleton from 'react-loading-skeleton'

export function ContentBoxedField (props) {
  const { children, label } = props

  const context = useContext(ContentBoxedDisplayContext)

  return <div className="profile-content">{label}: {context?.loading
    ? <Skeleton />
    : children
  }</div>
}

export default ContentBoxedField
